import { queryState, createState, updateState, fetchAllState } from "./creator";

export const queriedSubregions = queryState.selector;

export const createSubregionObj = createState.selector;

export const updateSubregionObj = updateState.selector;

export const fetchedSubregions = fetchAllState.selector;
